/* __next_internal_client_entry_do_not_use__ SDUIVerticalModalTextImageBannerRenderer auto */ import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { convertServerResponsivePropertyToClientResponsiveProperty } from "@faire/retailer-visitor-shared/components/SDUI/__internal__/Styling/responsiveValues";
import { buttonWidthContainer, centerAlignedWrapper } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Banner/__internal__/VerticalModalTextImageBanner/__internal__/style.css";
import { SDUIButtonRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Button/SDUIButtonRenderer";
import { SDUITypographyRenderer } from "@faire/retailer-visitor-shared/components/SDUI/ComponentRenderers/Typography/SDUITypographyRenderer";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { useIsSSR } from "@faire/web--source/common/server-side-rendering/isSSR";
import { optimizeImageUrlWidth } from "@faire/web--source/common/images/optimizeImages";
import styled, { css } from "styled-components";
import { Decorative } from "@faire/design-tokens";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import React from "react";
export var SDUIVerticalModalTextImageBannerRenderer = function(param) {
    var bannerComponent = param.bannerComponent, loggingData = param.loggingData, onClickClientDismissHandler = param.onClickClientDismissHandler;
    var images = bannerComponent.images, responsive_images = bannerComponent.responsive_images, title = bannerComponent.title, tagline = bannerComponent.tagline, description = bannerComponent.description, button = bannerComponent.button, disclaimer = bannerComponent.disclaimer;
    var isMobile = useViewport().isMobile;
    var isSSR = useIsSSR();
    var responsiveImages = convertServerResponsivePropertyToClientResponsiveProperty(images, function(img) {
        return img;
    }, responsive_images);
    var _responsiveImages_mobileAndAbove, _responsiveImages_desktopAndAbove;
    var imageViewport = isMobile ? ((_responsiveImages_mobileAndAbove = responsiveImages === null || responsiveImages === void 0 ? void 0 : responsiveImages.mobileAndAbove) !== null && _responsiveImages_mobileAndAbove !== void 0 ? _responsiveImages_mobileAndAbove : [])[0] : ((_responsiveImages_desktopAndAbove = responsiveImages === null || responsiveImages === void 0 ? void 0 : responsiveImages.desktopAndAbove) !== null && _responsiveImages_desktopAndAbove !== void 0 ? _responsiveImages_desktopAndAbove : [])[0];
    var optimizedImageUrl = imageViewport ? optimizeImageUrlWidth(imageViewport, isSSR, isMobile ? 430 : 400) : undefined;
    return /*#__PURE__*/ _jsx(Column, {
        children: /*#__PURE__*/ _jsxs(Background, {
            $url: isMobile ? optimizedImageUrl : undefined,
            children: [
                isMobile ? null : /*#__PURE__*/ _jsx(TopImage, {
                    src: optimizedImageUrl
                }),
                /*#__PURE__*/ _jsxs(Column, {
                    style: {
                        padding: getSpacing("5x", "4x")
                    },
                    children: [
                        tagline ? /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(SDUITypographyRenderer, {
                                    textElement: tagline,
                                    loggingData: loggingData
                                }),
                                /*#__PURE__*/ _jsx(Spacer, {
                                    height: "3x"
                                })
                            ]
                        }) : null,
                        title ? /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(SDUITypographyRenderer, {
                                    textElement: title,
                                    loggingData: loggingData
                                }),
                                /*#__PURE__*/ _jsx(Spacer, {
                                    height: {
                                        mobileAndAbove: "3x",
                                        tabletAndAbove: "2x"
                                    }
                                })
                            ]
                        }) : null,
                        description.length > 0 ? /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                description.map(function(descriptionElement, index) {
                                    return /*#__PURE__*/ _jsxs(React.Fragment, {
                                        children: [
                                            index > 0 ? /*#__PURE__*/ _jsx(Spacer, {
                                                height: "1/2x"
                                            }) : null,
                                            /*#__PURE__*/ _jsx(SDUITypographyRenderer, {
                                                textElement: descriptionElement,
                                                loggingData: loggingData
                                            })
                                        ]
                                    }, index);
                                }),
                                /*#__PURE__*/ _jsx(Spacer, {
                                    height: "3x"
                                })
                            ]
                        }) : null,
                        button ? /*#__PURE__*/ _jsxs("div", {
                            className: centerAlignedWrapper,
                            children: [
                                /*#__PURE__*/ _jsx(SDUIButtonRenderer, {
                                    buttonElement: button,
                                    className: buttonWidthContainer,
                                    loggingData: loggingData,
                                    fireLegacyOnClickEvent: true,
                                    onClickClientDismissHandler: onClickClientDismissHandler
                                }),
                                /*#__PURE__*/ _jsx(Spacer, {
                                    height: {
                                        mobileAndAbove: "3x",
                                        tabletAndAbove: "2x"
                                    }
                                })
                            ]
                        }) : null,
                        disclaimer ? /*#__PURE__*/ _jsx(_Fragment, {
                            children: /*#__PURE__*/ _jsx(SDUITypographyRenderer, {
                                textElement: disclaimer,
                                loggingData: loggingData
                            })
                        }) : null
                    ]
                })
            ]
        })
    });
};
var Background = styled(Column).withConfig({
    componentId: "sc-47d6927b-0"
})([
    "",
    " ",
    "{min-height:100vh;}"
], function(props) {
    return props.$url ? css([
        "background:url(",
        ") center / cover no-repeat;"
    ], props.$url) : css([
        "background-color:",
        ";"
    ], Decorative.tint.neutral);
}, responsiveMediaQueries.mobile);
var TopImage = styled.img.withConfig({
    componentId: "sc-47d6927b-1"
})([
    "display:block;width:100%;object-fit:cover;object-position:0 85%;height:200px;"
]);
